// Date helpers for Tab A / Tab B filters. All in Asia/Jerusalem when interpreted
// as a calendar boundary; YYYY-MM-DD strings on the wire.

export function todayIsrael(): string {
  // toLocaleDateString with the IL locale + en-CA gives YYYY-MM-DD.
  return new Date().toLocaleDateString('en-CA', { timeZone: 'Asia/Jerusalem' });
}

export function firstOfMonthIsrael(date: Date = new Date()): string {
  const ymd = date.toLocaleDateString('en-CA', {
    timeZone: 'Asia/Jerusalem',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
  return `${ymd.slice(0, 7)}-01`;
}

export function lastOfMonthIsrael(date: Date = new Date()): string {
  const ymd = date.toLocaleDateString('en-CA', {
    timeZone: 'Asia/Jerusalem',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
  const [y, m] = ymd.split('-').map(Number);
  // Day 0 of next month = last day of this month.
  const last = new Date(Date.UTC(y!, m!, 0)).getUTCDate();
  return `${ymd.slice(0, 7)}-${String(last).padStart(2, '0')}`;
}

/** YYYY-MM-DD → DD/MM/YYYY for display in RTL Hebrew UI. */
export function isoToDisplay(iso: string | null | undefined): string {
  if (!iso) return '—';
  const m = iso.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return iso;
  return `${m[3]}/${m[2]}/${m[1]}`;
}

/** ISO timestamp → "HH:MM" in Asia/Jerusalem; '—' for null/empty. */
export function formatTime(iso: string | null | undefined): string {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleTimeString('he-IL', {
      timeZone: 'Asia/Jerusalem',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });
  } catch {
    return '—';
  }
}
